"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEAREST_AIRPORT_API = exports.LOGIN_TOOLTIP_SHOWED_SESSION_LABEL = exports.LOCAL_CURRENCY_EXPIRY = exports.LOCALE_LIST = exports.LOCALE_LABEL = exports.LOCALE_COOKIE_LABEL = exports.HOTJAR_LOGIN_STATUS = exports.HEADER_COMPONENTS = exports.HAMBURGER_VALUES = exports.ENVIRONMENT = exports.DISABLE_HOTJAR_GEOCOUNTRY = exports.DIRECTION = exports.DESKTOP_BREAKPOINT = exports.DEFAULT_STYLE = exports.DEFAULT_LOCALE = exports.DEFAULT_GTM_PARAMS = exports.DEFAULT_CURRENCY = exports.CURRENCY_LIST = exports.CURRENCY_LABEL = exports.CURRENCY_COOKIE_LABEL = exports.A11Y_DIMENTIONS = void 0;

/* eslint-disable max-len */
var DEFAULT_STYLE = {
  DEFAULT_BACKGROUND_COLOR: 'default',
  DEFAULT_TEXT_COLOR: 'greyDarker',
  DEFAULT_TEXT_HOVER_COLOR: 'primary',
  DEFAULT_TEXT_ACTIVE_COLOR: 'primaryDark'
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;
var HEADER_COMPONENTS = {
  LOGO: 'logo',
  NAVIGATION: 'navigation',
  CUSTOM_COMPONENTS: 'custom-component',
  LOCALE_CURRENCY: 'locale-currency',
  LOGIN: 'login',
  CHANGE_CURRENCY: 'change-currency'
};
exports.HEADER_COMPONENTS = HEADER_COMPONENTS;
var LOCALE_COOKIE_LABEL = 'uhfLocale';
exports.LOCALE_COOKIE_LABEL = LOCALE_COOKIE_LABEL;
var CURRENCY_COOKIE_LABEL = 'uhfCurrency';
exports.CURRENCY_COOKIE_LABEL = CURRENCY_COOKIE_LABEL;
var LOCAL_CURRENCY_EXPIRY = 43200;
exports.LOCAL_CURRENCY_EXPIRY = LOCAL_CURRENCY_EXPIRY;
var LOCALE_LABEL = 'locale';
exports.LOCALE_LABEL = LOCALE_LABEL;
var CURRENCY_LABEL = 'currency';
exports.CURRENCY_LABEL = CURRENCY_LABEL;
var DEFAULT_LOCALE = 'en-gb';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var DEFAULT_CURRENCY = 'USD';
exports.DEFAULT_CURRENCY = DEFAULT_CURRENCY;
var DESKTOP_BREAKPOINT = 1280;
exports.DESKTOP_BREAKPOINT = DESKTOP_BREAKPOINT;
var LOGIN_TOOLTIP_SHOWED_SESSION_LABEL = 'loginTooltipShowed';
exports.LOGIN_TOOLTIP_SHOWED_SESSION_LABEL = LOGIN_TOOLTIP_SHOWED_SESSION_LABEL;
var ENVIRONMENT = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production'
};
exports.ENVIRONMENT = ENVIRONMENT;
var DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
};
exports.DIRECTION = DIRECTION;
var HAMBURGER_VALUES = {
  LOCALE: 'Language',
  CURRENCY: 'Currency'
};
exports.HAMBURGER_VALUES = HAMBURGER_VALUES;
var LOCALE_LIST = ['en-gb', 'th-th', 'id-id', 'zh-cn', 'zh-tw', 'zh-hk', 'ja-jp', 'ko-kr', 'ms-my', 'vi-vn'];
exports.LOCALE_LIST = LOCALE_LIST;
var CURRENCY_LIST = ['AUD', 'CNY', 'EUR', 'GBP', 'HKD', 'JPY', 'MYR', 'NZD', 'PHP', 'SGD', 'THB', 'USD', 'BDT', 'BND', 'INR', 'IDR', 'KRW', 'MOP', 'TWD', 'VND'];
exports.CURRENCY_LIST = CURRENCY_LIST;
var DEFAULT_GTM_PARAMS = {
  event: 'trackEventNoEcommerce',
  eventCategory: 'uhf',
  eventActionClick: 'click',
  eventLabelLocaleCurrency: 'Language & Currency | {{label}}',
  eventLabelLocale: 'choose a language | {{oldlocale}} - {{newlocale}}',
  eventLabelCurrency: 'choose a currency | {{oldcurrency}} - {{newcurrency}}'
};
exports.DEFAULT_GTM_PARAMS = DEFAULT_GTM_PARAMS;
var HOTJAR_LOGIN_STATUS = {
  LOGIN: 'loggedIn',
  NONLOGIN: 'non-LoggedIn'
};
exports.HOTJAR_LOGIN_STATUS = HOTJAR_LOGIN_STATUS;
var NEAREST_AIRPORT_API = 'https://t.airasia.com/nearestairport/airport/user';
exports.NEAREST_AIRPORT_API = NEAREST_AIRPORT_API;
var DISABLE_HOTJAR_GEOCOUNTRY = ['CN'];
exports.DISABLE_HOTJAR_GEOCOUNTRY = DISABLE_HOTJAR_GEOCOUNTRY;
var A11Y_DIMENTIONS = '1px';
exports.A11Y_DIMENTIONS = A11Y_DIMENTIONS;